const projects = {
  "myPageModal": {
    "menuLabel": "마이페이지 메뉴",
    "account": {
      "editField": "{{field}} 수정",
      "saveField": "{{field}} 저장",
      "cancelEdit": "{{field}} 수정 취소",
      "saving": "저장 중",
      "requiredError": "값을 입력해 주세요.",
      "phoneError": "올바른 전화번호 형식이 아닙니다.",
      "emptyValue": "값 없음"
    },
    "logout": {
      "message": "로그아웃하시겠습니까?",
      "signingOut": "로그아웃 중"
    },
    "withdrawal": {
      "description": "아래 안내를 확인하고 동의해 주세요.",
      "processing": "처리 중",
      "ownedProjectNotice": "소유하신 프로젝트가 있으면 탈퇴하실 수 없습니다. 프로젝트를 삭제하시거나 소유권을 다른 멤버에게 이전하신 뒤 탈퇴해 주세요.",
      "retentionNotice": "탈퇴하시면 이름, 이메일 주소 등 계정 정보는 바로 삭제되며 되돌릴 수 없습니다. 참여하신 프로젝트에 남기신 이슈, 댓글, 사진, 측정 기록은 다른 구성원을 위해 프로젝트에 남고, 작성자는 \"{{unknownLabel}}\"으로 표시됩니다.",
      "retryNotice": "계정 정보는 삭제되었지만 로그인 계정 삭제가 끝나지 않았습니다. {{confirmLabel}}를 한 번 더 눌러 마무리해 주세요."
    },
    "permission": {
      "members": "멤버",
      "memberList": "멤버 목록",
      "roleGroup": "{{name}} 권한",
      "deleteMember": "{{name}} 삭제",
      "noChanges": "변경 사항 없음",
      "changeCount": "변경 {{count}}건",
      "noMembers": "멤버가 없습니다",
      "deleteTitle": "멤버 삭제",
      "deleteMessage": "'{{name}}' 멤버를 삭제하시겠습니까?",
      "deleteSubMessage": "삭제한 멤버는 되돌릴 수 없습니다",
      "emailLabel": "이메일",
      "emailRequired": "이메일을 입력해주세요.",
      "emailInvalid": "이메일 형식이 올바르지 않습니다. 다시 확인해 주세요.",
      "emailExists": "이미 존재하는 이메일입니다.",
      "serverError": "서버 에러입니다. 관리자에게 문의 부탁드립니다.",
      "adding": "추가 중",
      "resetDone": "변경사항이 초기화되었습니다.",
      "noOwnProjectTitle": "소유자(owner)로 등록된 프로젝트가 없습니다",
      "noOwnProjectDescription": "프로젝트 권한 관리는 소유자만 할 수 있습니다.",
      "transfer": {
        "title": "소유권 이전",
        "warning": "이전하면 이 프로젝트의 소유권이 새 소유자에게 넘어가고, 회원님은 이 프로젝트에서 빠집니다. 되돌릴 수 없습니다.",
        "emailLabel": "새 소유자 이메일",
        "submit": "이전",
        "transferring": "이전 중",
        "notFound": "이 이메일의 가입자를 찾을 수 없거나(미가입·탈퇴), 회원님이 더는 이 프로젝트의 소유자가 아닙니다.",
        "titleConflict": "새 소유자에게 같은 이름의 프로젝트가 있어 이전할 수 없습니다. 프로젝트 이름을 바꾼 뒤 다시 시도해 주세요.",
        "invalidTarget": "자기 자신이나 관리자 계정에는 이전할 수 없거나, 요청 형식이 올바르지 않습니다.",
        "failed": "소유권 이전에 실패했습니다. 잠시 후 다시 시도해 주세요."
      }
    },
    "select": {
      "noResult": "검색 결과가 없습니다"
    },
    "history": {
      "timeline": "프로젝트 기록",
      "loadingMore": "불러오는 중"
    }
  },
  "queryState": {
    "projectListLoadFailed": "프로젝트 목록을 불러오지 못했습니다",
    "ownProjectListLoadFailed": "소유 프로젝트 목록을 불러오지 못했습니다",
    "memberListLoadFailed": "멤버 목록을 불러오지 못했습니다",
    "droneImageListLoadFailed": "드론 이미지 목록을 불러오지 못했습니다",
    "droneImageSizeLoadFailed": "드론 이미지 원본 크기를 불러오지 못했습니다",
    "gcpFileLoadFailed": "GCP 파일 정보를 불러오지 못했습니다",
    "layerDataLoadFailed": "파일 목록을 불러오지 못했습니다",
    "layerDataLoadFailedNamed": "{{name}} 파일 목록을 불러오지 못했습니다",
    "drawingListLoadFailed": "설계도 목록을 불러오지 못했습니다",
    "drawingListLoadFailedNamed": "{{name}} 목록을 불러오지 못했습니다",
    "orthomosaicImageLoadFailed": "정사영상 미리보기를 불러오지 못했습니다",
    "earthworkZoneListLoadFailed": "구역 목록을 불러오지 못했습니다",
    "earthworkSurfaceListLoadFailed": "도면과 설계 표면 목록을 불러오지 못했습니다",
    "earthworkSurfaceNameLoadFailed": "표면 이름을 불러오지 못했습니다",
    "earthworkEpochListLoadFailed": "촬영 회차 목록을 불러오지 못했습니다",
    "earthworkPermissionLoadFailed": "프로젝트 권한 정보를 불러오지 못했습니다",
    "earthworkPermissionChecking": "프로젝트 권한을 확인하는 중입니다",
    "earthworkProjectLoadFailed": "프로젝트 정보를 불러오지 못했습니다",
    "earthworkResultLoadFailed": "토공 산출 결과를 불러오지 못했습니다",
    "earthworkStartFailed": "토공 산출을 시작하지 못했습니다",
  },
  "earthwork": {
    "noSiteDrawingTitle": "이 프로젝트에는 단지 토공용 도면이 없습니다",
    "noSiteDrawingHint": "도면이 단지용으로 지정되고 변환이 끝난 뒤 페이지를 새로고침하면 이곳에 나타납니다.",
    "computeUnavailable": "단지 토공용 도면이 없어 토공량을 계산할 수 없습니다.",
    "sidebarDisabled": {
      "noEarthworkSource": "이 프로젝트에는 토공에 쓸 단지 도면이나 선형 레이어가 없어 열 수 없습니다",
      "sourceUnreadable": "설계도나 레이어 목록을 불러오지 못해 열 수 없습니다",
      "needsCompletedTimeSeries": "완료된 시계열을 골라야 열 수 있습니다",
      "timeSeriesUnreadable": "시계열 목록을 불러오지 못해 열 수 없습니다",
      "checking": "열 수 있는지 확인하는 중입니다",
      "meshNotBuilt": "3D(mesh)가 아직 구축되지 않아 열 수 없습니다",
      "twoDNotBuilt": "2D(정사영상 · DEM)가 아직 구축되지 않아 열 수 없습니다"
    }
  },
  "drawingBundle": {
    "expand": "묶음 펼치기",
    "collapse": "묶음 접기",
    "memberCount": "도면 {{count}}개",
    "expanding": "묶음 여는 중",
    "failed": "묶음 열기 실패",
    "pending": "변환 대기 {{count}}",
    "uploaded": "묶음 {{name}} 업로드 완료 — 도면 {{count}}개 등록, 변환이 끝나면 묶음 안에 나타납니다",
    "uploadFailed": "묶음 {{name}} 업로드에 실패했습니다 — {{reason}}",
    "nameInput": "묶음 이름 입력"
  },
  "drawingPair": {
    "title": "설계도 업로드",
    "hint": "도면마다 정렬 dxf 하나가 필요합니다.",
    "drawingColumn": "도면",
    "alignmentColumn": "정렬 dxf",
    "alignmentMissing": "정렬 dxf 없음",
    "pickAlignment": "{{name}} 정렬 dxf 선택",
    "pick": "선택",
    "replace": "변경",
    "unpairedCount": "정렬 dxf 가 없는 도면 {{count}}개",
    "orphanNotice": "짝을 찾지 못한 dxf: {{names}}",
    "submit": "업로드",
    "submitLabel": "설계도 쌍 업로드",
    "submitBlockedLabel": "정렬 dxf 가 없는 도면 {{count}}개 — 업로드할 수 없습니다",
    "cancel": "취소",
    "close": "닫기",
    "dwgRequired": "도면(.dwg) 파일이 없습니다. 도면과 정렬 dxf 를 함께 선택해주세요.",
    "lonelyDxfSkipped": "짝이 되는 도면(.dwg)이 없는 dxf {{count}}개는 올리지 않았습니다.",
    "alignmentUploadFailed": "정렬 dxf 업로드에 실패했습니다 — {{names}}",
    "gapTitle": "정렬이 비어 있는 도면 {{count}}개",
    "gapDescription": "도면은 올라갔지만 정렬 dxf 가 비어 있습니다. 정렬이 비면 빌드할 수 없습니다.",
    "retry": "정렬 다시 올리기",
    "retryLabel": "정렬 dxf 다시 올리기"
  },
  "sidebar": {
    "timeSeries": "시계열 점검",
    "calendar": "캘린더",
    "road": "도로 포장",
    "graph": "그래프",
    "ship": "선박"
  },
  "menu": {
    "timeSeries": "시계열 점검",
    "roadDetection": "도로 포장 이슈 탐지"
  },
  "dashboard": {
    "title": "프로젝트",
    "searchPlaceholder": "프로젝트 검색",
    "noProjects": "프로젝트가 없습니다",
    "noSearchedTags": "검색된 태그가 없습니다",
    "loading": "로딩 중...",
    "countLoading": "개수 확인 중",
    "filterApplied": "필터, {{count}}개 적용 중",
    "tagFilter": "태그 필터"
  },
  "modal": {
    "addProject": "프로젝트 추가",
    "editTimeSeries": "시계열 수정",
    "editProject": "프로젝트 정보 수정",
    "steps": {
      "location": "위치",
      "projectInfo": "프로젝트 정보",
      "addTimeSeries": "시계열 추가"
    },
    "projectName": "프로젝트명",
    "projectNamePlaceholder": "프로젝트명을 입력해 주세요",
    "address": "주소",
    "location": "위치",
    "changeLocation": "바꾸기",
    "addressSearchPlaceholder": "주소를 검색하거나 지도를 누르세요",
    "infraType": "인프라 타입",
    "infraTypeInputPlaceholder": "인프라 타입을 입력해 주세요",
    "objectType": "객체 타입",
    "selectPlaceholder": "선택해 주세요",
    "objectTypeExample": "예: 교량",
    "tags": "태그",
    "tagsPlaceholder": "태그를 선택하거나 새로 추가(Enter)하세요",
    "memo": "메모",
    "memoPlaceholder": "메모를 입력해 주세요",
    "datePlaceholder": "날짜를 선택해 주세요",
    "comment": "코멘트",
    "commentPlaceholder": "코멘트를 입력해 주세요",
    "required": "&#42;",
    "cancel": "취소",
    "next": "다음",
    "previous": "이전",
    "save": "저장",
    "add": "추가",
    "apply": "적용",
    "feedback": {
      "projectCreated": "프로젝트 생성 성공",
      "projectCreateFailed": "프로젝트 생성 실패",
      "duplicateProjectName": "동일한 프로젝트 명이 존재합니다.",
      "timeSeriesOwnerOnly": "시계열은 프로젝트 소유자만 추가·수정할 수 있습니다"
    },
    "state": {
      "addressSearchFailed": "주소 검색 결과를 불러오지 못했습니다",
      "addressNoResult": "검색 결과가 없습니다",
      "projectInfoLoadFailed": "프로젝트 정보를 불러오지 못했습니다",
      "timeSeriesInfoLoadFailed": "시계열 정보를 불러오지 못했습니다"
    },
    "a11y": {
      "stepProgress": "진행 단계",
      "reselectInfraType": "인프라 타입 다시 고르기",
      "removeTag": "{{tag}} 태그 빼기",
      "adding": "추가 중",
      "saving": "저장 중",
      "addressSearching": "주소 찾는 중",
      "addressResults": "주소 검색 결과",
      "tagsLoading": "태그 불러오는 중",
      "tagList": "태그 목록",
      "projectInfoLoading": "프로젝트 정보 불러오는 중",
      "timeSeriesInfoLoading": "시계열 정보 불러오는 중"
    }
  },
  "table": {
    "columns": {
      "name": "프로젝트명",
      "location": "위치",
      "date": "날짜",
      "status": "상태",
      "actions": "작업",
      "memo": "메모",
      "mappingStatus": "이미지 매핑 상태",
      "timeSeriesCount": "시계열"
    },
    "status": {
      "completed": "완료",
      "processing": "처리 중",
      "pending": "대기 중",
      "failed": "실패"
    },
    "addTimeSeries": "시계열 추가",
    "createNewProject": "새 프로젝트를 생성하세요.",
    "lastModified": "최근 수정일",
    "memoSearch": "메모 검색",
    "noMemoResults": "검색된 메모가 없습니다",
    "noSearchResult": "검색 결과가 없습니다",
    "listLoading": "프로젝트 목록 불러오는 중",
    "searching": "검색 중"
  },
  "details": {
    "title": "프로젝트 상세",
    "information": "프로젝트 정보",
    "timeSeries": "시계열 데이터",
    "noData": "데이터가 없습니다",
    "projectName": "프로젝트명",
    "location": "위치",
    "createdAt": "생성일",
    "updatedAt": "수정일",
    "description": "설명",
    "unknown": "알 수 없음"
  },
  "map": {
    "title": "프로젝트 위치",
    "noLocation": "위치 정보가 없습니다",
    "preview": "위치 미리보기"
  },
  "tabs": {
    "information": "정보",
    "droneImage": "드론 이미지",
    "layerData": "레이어 데이터",
    "terrainData": "지형 고도 데이터",
    "referenceData": "참고 데이터"
  },
  "information": {
    "details": "세부 정보",
    "edit": "수정",
    "address": "주소",
    "coordinates": "위경도",
    "latitude": "위도",
    "longitude": "경도",
    "infraType": "인프라/객체 타입",
    "tags": "태그",
    "memo": "메모",
    "thumbnail": "썸네일",
    "noImage": "이미지 없음",
    "noPreviewTarget": "미리보기를 조회할 시계열이 없습니다"
  },
  "layerTypes": {
    "stratum": "지층",
    "designHeight": "계획고",
    "designProfile": "원지반고",
    "drawing": "설계도"
  },
  "dataTypes": {
    "image": "이미지",
    "document": "문서",
    "video": "비디오",
    "gis": "GIS",
    "line": "선형 Layer",
    "bim": "BIM",
    "pointCloud": "Point Cloud"
  },
  "droneImage": {
    "selectAll": "전체 선택",
    "uploadedImages": "업로드된 이미지",
    "uploadingImages": "업로드 중인 이미지",
    "targetImages": "업로드 대상 이미지",
    "totalSize": "총 용량",
    "uploadImages": "이미지 업로드",
    "uploadImagesCount": "이미지 업로드",
    "uploading": "업로드 중",
    "uploadingMessage": "전송 완료 시까지 현재 화면을 유지해주세요",
    "uploadSuccess": "이미지 업로드가 완료되었습니다.",
    "uploadFailed": "이미지 업로드에 실패했습니다.",
    "deleteSuccess": "이미지 삭제가 완료되었습니다.",
    "deleteFailed": "이미지 삭제에 실패했습니다.",
    "deleting": "삭제 중...",
    "loading": "로딩 중...",
    "noValidImages": "유효한 이미지 파일(.jpg, .jpeg)이 없습니다.",
    "addImagesGuide": "이미지 추가 탭에서 이미지를 추가"
  },
  "file": {
    "download": "다운로드",
    "delete": "삭제",
    "upload": "업로드",
    "refresh": "새로고침",
    "downloadNamed": "{{name}} 다운로드",
    "deleteNamed": "{{name}} 삭제",
    "uploadNamed": "{{name}} 업로드",
    "previewNamed": "{{name}} 미리보기",
    "deleteSuccess": "파일 삭제가 완료되었습니다.",
    "deleteFailed": "파일 삭제에 실패했습니다.",
    "downloadFailed": "파일 다운로드에 실패했습니다.",
    "uploading": "업로드 중",
    "uploadingMessage": "전송 완료 시까지 현재 화면을 유지해주세요",
    "skippedUnsupported": "지원하지 않는 형식의 파일 {{count}}개는 제외했습니다."
  },
  "layerRename": {
    "renameLayer": "이름 변경",
    "renameLayerNamed": "{{name}} 이름 변경",
    "layerNameInput": "레이어 이름 입력",
    "renameDuplicate": "이미 사용 중인 이름입니다. 다른 이름을 입력해주세요.",
    "renameInvalid": "사용할 수 없는 이름입니다. 이름은 1~100자여야 합니다.",
    "renameNoPermission": "이름을 변경할 권한이 없거나 대상을 찾을 수 없습니다.",
    "renameFailed": "레이어 이름 변경에 실패했습니다."
  },
  "timeSeries": {
    "mappingInfo": "매핑 정보",
    "imageMapping": "이미지 매핑",
    "mappingRequest": "매핑 요청",
    "requestCompleted": "요청 완료",
    "gcpUpload": "GCP 업로드",
    "gcp": "GCP",
    "gcpAutoDetect": "자동 인식",
    "gcpAutoDetectHint": "드론스퀘어 표준 표식을 설치한 GCP일 때 켜세요. GCP 파일을 올린 뒤에 켤 수 있습니다.",
    "gcpAutoDetectSaveFailed": "GCP 자동 인식 설정을 변경하지 못했습니다.",
    "gcpAutoDetectBlocked": {
      "GCP_FILE_UNREADABLE": "$t(timeSeries.gcpGuide.unreadableFormats) 파일은 자동 인식이 읽지 못합니다. csv나 xlsx로 저장해 다시 올리세요.",
      "NO_PHOTOS": "드론 사진을 올리면 자동 인식을 켤 수 있습니다."
    },
    "gcpFilesUsedTogether": "GCP 파일이 여러 개면 모두 함께 씁니다.",
    "autoBuild": {
      "inProgressTitle": "자동 처리 중",
      "phase": {
        "waiting": "1/3 대기 — 처리 서버의 차례를 기다리고 있습니다.",
        "processing": "2/3 처리 — 사진과 GCP를 받아 결과물을 만들고 있습니다.",
        "publishing": "3/3 결과 반영 — 만든 결과물을 올리고 있습니다."
      },
      "phaseUnknown": "자동 구축으로 처리하고 있습니다.",
      "completed": "자동 구축으로 완료",
      "handedOverTitle": "자동 구축 대신 담당자가 처리합니다",
      "reasonUnknown": "담당자가 이어서 처리합니다.",
      "reasons": {
        "markers": {
          "what": "표식을 충분히 찾지 못했거나, 표식이 촬영 범위를 고르게 덮지 못했습니다.",
          "nextTime": "다음 회차에는 GSD {{gcpGsdLimitCm}} cm 이하로 낮게 날고, 그림자 없는 곳에 표식을 6개 이상(최소 5개) 촬영 범위의 모서리까지 고르게 두세요. GCP 파일에는 표식을 깐 점만 적습니다."
        },
        "gcp_file": {
          "what": "GCP 파일을 읽지 못했거나, 좌표가 촬영 범위와 맞지 않았습니다.",
          "nextTime": "다음 회차에는 $t(timeSeries.gcpGuide.readableFormats) 파일에 한 줄에 라벨·X·Y·Z를 EPSG:5185~5188 좌표로 적어 올리세요."
        },
        "photos": {
          "what": "사진이 자동 구축 조건에 맞지 않았습니다.",
          "nextTime": "다음 회차에는 허용 기체($t(timeSeries.gcpGuide.allowedAircraft))로 RTK fixed 상태에서, 광각 RGB 카메라 하나로, 중복도 진행 65%·옆 60% 이상으로 찍으세요."
        },
        "accuracy": {
          "what": "정합 결과가 정확도 기준을 넘지 못했습니다.",
          "nextTime": "다음 회차에는 표식 중심을 측량했는지, 높이가 정표고(KNGeoid) 기준인지 확인하세요."
        },
        "internal": {
          "what": "처리 서버 사정으로 자동 구축을 마치지 못했습니다.",
          "nextTime": "다음 회차에도 그대로 자동 인식을 쓰시면 됩니다."
        }
      }
    },
    "autoBuildRejected": {
      "AUTO_BUILD_UNAVAILABLE": "이 환경은 자동 구축을 쓰지 않습니다.",
      "AUTO_DETECT_OFF": "자동 인식이 꺼져 있어 자동 구축을 요청할 수 없습니다. GCP 행에서 [$t(timeSeries.gcpAutoDetect)]을 켜고 다시 요청하세요.",
      "GCP_FILE_MISSING": "GCP 파일이 없어 자동 구축을 쓸 수 없습니다. GCP 행에서 GCP 파일을 올리세요.",
      "GCP_FILE_UNREADABLE": "자동 구축이 읽지 못하는 GCP 파일이 있습니다. $t(timeSeries.gcpGuide.readableFormats)로 저장해 다시 올리세요.",
      "NO_PHOTOS": "드론 사진이 없어 자동 구축을 쓸 수 없습니다.",
      "AUTO_DETECT_LOCKED": "매핑을 요청한 뒤에는 자동 인식을 바꿀 수 없습니다.",
      "NO_RGB_PHOTOS": "자동 구축이 처리할 RGB 사진이 없습니다(열화상이거나 읽을 수 없는 사진뿐입니다). 이번 회차는 [$t(timeSeries.gcpAutoDetect)] 없이 요청하면 담당자가 처리합니다. 촬영 조건은 「$t(timeSeries.gcpGuide.title)」에 있습니다.",
      "MULTI_SENSOR": "여러 카메라로 찍은 사진이 섞여 있어 자동 구축을 쓸 수 없습니다(광각 RGB 카메라 하나로 찍은 사진만 받습니다). 이번 회차는 [$t(timeSeries.gcpAutoDetect)] 없이 요청하면 담당자가 처리합니다. 촬영 조건은 「$t(timeSeries.gcpGuide.title)」에 있습니다.",
      "DRONE_UNSUPPORTED": "자동 구축이 지원하지 않는 기체로 찍은 사진입니다. 지원 기체는 $t(timeSeries.gcpGuide.allowedAircraft)입니다. 이번 회차는 [$t(timeSeries.gcpAutoDetect)] 없이 요청하면 담당자가 처리합니다. 촬영 조건은 「$t(timeSeries.gcpGuide.title)」에 있습니다.",
      "NO_GNSS": "EXIF에 GNSS 위치가 없는 사진이 있어 자동 구축을 쓸 수 없습니다. 이번 회차는 [$t(timeSeries.gcpAutoDetect)] 없이 요청하면 담당자가 처리합니다. 촬영 조건은 「$t(timeSeries.gcpGuide.title)」에 있습니다.",
      "RTK_NOT_FIXED": "RTK fixed 상태로 찍지 않은 사진이 있어 자동 구축을 쓸 수 없습니다. 이번 회차는 [$t(timeSeries.gcpAutoDetect)] 없이 요청하면 담당자가 처리합니다. 촬영 조건은 「$t(timeSeries.gcpGuide.title)」에 있습니다."
    },
    "autoBuildRejectedUnknown": "이 자료는 자동 구축을 쓸 수 없습니다. [$t(timeSeries.gcpAutoDetect)] 없이 요청하면 담당자가 처리합니다.",
    "mappingRequestResult": {
      "succeeded": "매핑 요청이 완료되었습니다.",
      "alreadyRequested": "이미 매핑을 요청했거나 처리 중인 시계열입니다.",
      "failed": "매핑 요청에 실패했습니다."
    },
    "mappingAutoBuildNotice": "GCP 자동 인식이 켜져 있어 매핑이 자동으로 진행됩니다.",
    "mappingRequestModal": {
      "title": "이미지 매핑을 요청하시나요?",
      "description": "매핑 요청이 완료된 프로젝트의 경우, 이미지 리스트에서 이미지를 삭제하거나 추가 업로드 할 수 없습니다.",
      "confirm": "요청",
      "autoBuildConditions": "아래 조건이 하나라도 맞지 않으면 담당자가 처리하며 시간이 더 걸립니다.",
      "turnOnAutoDetect": "드론스퀘어 표준 표식을 깔고 촬영했다면 GCP 행의 [$t(timeSeries.gcpAutoDetect)]을 켜고 요청하세요.",
      "manualThisTime": "이번 요청은 담당자가 처리합니다."
    },
    "gcpGuide": {
      "open": "$t(timeSeries.gcpGuide.title)",
      "title": "GCP 자동 인식 가이드",
      "aircraft": {
        "m3e": "Mavic 3E",
        "m4": "Matrice 4E/4D",
        "p4rtk": "Phantom 4 RTK",
        "p1_35": "Zenmuse P1 35 mm"
      },
      "allowedAircraft": "$t(timeSeries.gcpGuide.aircraft.m3e)·$t(timeSeries.gcpGuide.aircraft.m4)·$t(timeSeries.gcpGuide.aircraft.p4rtk)·$t(timeSeries.gcpGuide.aircraft.p1_35)",
      "readableFormats": "csv·txt·xlsx",
      "unreadableFormats": "xls",
      "what": {
        "title": "자동 인식이란",
        "items": [
          "GCP 위치에 드론스퀘어 표준 표식을 깔고 촬영하면, 시스템이 사진에서 표식을 찾아 GCP를 자동으로 맞춥니다. 사진마다 GCP를 찍을 필요가 없습니다."
        ]
      },
      "checklist": {
        "title": "자동 처리 조건",
        "items": [
          "드론스퀘어 표준 표식(한 변 {{gcpMarkerSideCm}} cm)을 5개 이상 고르게 깔고, 깐 날 표식 중심을 측량합니다.",
          "DJI RTK 기체($t(timeSeries.gcpGuide.allowedAircraft))로 RTK fixed 상태에서, 광각 RGB 카메라 하나로 촬영합니다.",
          "지상 해상도(GSD) {{gcpGsdLimitCm}} cm 이하로 촬영합니다.",
          "GCP 파일($t(timeSeries.gcpGuide.readableFormats))에는 이번에 표식을 깐 점만 적습니다.",
          "높이(Z)는 정표고(KNGeoid)로 적습니다."
        ]
      },
      "prepare": {
        "title": "표식 준비",
        "printFile": "100% 배율로 {{gcpMarkerSideMm}} × {{gcpMarkerSideMm}} mm(재단선 기준)에 맞춰 인쇄하세요.",
        "previewAlt": "드론스퀘어 표준 표식 미리보기 — 왼쪽 위와 오른쪽 아래 칸이 검은 2×2 흑백 체커 정사각형 판",
        "downloadPdf": "PDF 내려받기",
        "downloadSvg": "SVG 내려받기",
        "downloadA1": "A1 타일 PDF 내려받기",
        "a1Note": "A1 용지 2장에 나눠 인쇄해 이어 붙이는 파일입니다.",
        "items": [
          "한 변 {{gcpMarkerSideCm}} cm의 흑백 2×2 체커입니다. 왼쪽 위·오른쪽 아래 칸이 검정이고, 테두리와 번호가 없습니다. 무광을 권장합니다.",
          "같은 무늬의 시판 {{gcpMarkerSideCm}} cm 판도 쓸 수 있습니다. 테두리·번호가 있거나 무늬가 다른 판은 쓸 수 없습니다.",
          "직접 만들 때는 무광 현수막에 인쇄하고 네 모서리에 고정 고리를 답니다. GCP 수만큼 준비합니다."
        ]
      },
      "install": {
        "title": "설치와 측량",
        "items": [
          "표식을 깐 날, 표식 중심(두 검은 칸이 맞닿는 점)을 측량합니다.",
          "평평하게 펴서 네 모서리를 고정하고, 물기·먼지·그림자가 없는 곳에 둡니다.",
          "6개 이상(최소 5개)을 촬영 범위의 모서리까지 고르게 둡니다. 표식이 둘러싼 넓이가 촬영 범위의 30%보다 작으면 자동 처리되지 않습니다.",
          "(선택) 검사점을 두려면 GCP 파일에 기준점은 GCP1·GCP2…, 검사점은 CP1·CP2…로 적습니다."
        ]
      },
      "flight": {
        "title": "촬영",
        "itemsBeforeTable": [
          "GSD {{gcpGsdLimitCm}} cm 이하로 촬영합니다. {{gcpGsdFalloffCm}} cm를 넘으면 표식을 찾기 어려워 담당자 처리로 넘어가기 쉽습니다."
        ],
        "tableCaption": "GSD {{gcpGsdLimitCm}} cm가 되는 대략적인 고도(지면 기준, 비행 앱의 GSD로 확인)",
        "tableHeaders": {
          "aircraft": "기체",
          "altitude": "지면 기준 고도"
        },
        "tableRows": {
          "m3e": "$t(timeSeries.gcpGuide.aircraft.m3e)·$t(timeSeries.gcpGuide.aircraft.m4)",
          "p4rtk": "$t(timeSeries.gcpGuide.aircraft.p4rtk)",
          "p1_35": "$t(timeSeries.gcpGuide.aircraft.p1_35)"
        },
        "tableAltitude": "약 {{meters}} m",
        "validatedRangeNote": "{{aircraft}}: {{meters}} m까지 검증된 고도입니다.",
        "itemsAfterTable": [
          "중복도는 진행 65%·옆 60% 이상으로 합니다.",
          "표식마다 사진 5장 이상에 온전히 찍히게 합니다."
        ]
      },
      "upload": {
        "title": "업로드와 요청",
        "items": [
          "사진과 GCP 파일을 평소처럼 올리고, GCP 행의 [$t(timeSeries.gcpAutoDetect)]을 켠 뒤 매핑을 요청합니다.",
          "GCP 파일은 $t(timeSeries.gcpGuide.readableFormats)만 읽습니다($t(timeSeries.gcpGuide.unreadableFormats)는 안 됩니다). 한 줄에 라벨, X, Y, Z를 적고, 좌표계는 EPSG:5185~5188입니다. X·Y 순서는 상관없습니다.",
          "높이에 현장 TBM·기본수준면(DL)·타원체고 기준 값을 쓰지 않습니다.",
          "GCP 파일은 회차마다 올립니다(앞 회차와 같아도)."
        ]
      },
      "fallback": {
        "title": "자동으로 처리되지 않을 때",
        "items": [
          "표식을 충분히 찾지 못하거나 품질 기준에 못 미치면 담당자가 기존 방식으로 처리합니다.",
          "결과물 품질은 같고, 따로 하실 일은 없습니다."
        ]
      }
    },
    "completionDate": "완료일",
    "coordinateSystem": "출력 좌표계",
    "resolution": "해상도(GSD)",
    "images": "이미지(최적화/원시)",
    "download": "다운로드",
    "preview": "미리보기",
    "orthomosaic": "정사영상[TIF]",
    "pointCloud": "3D 포인트 클라우드[LAS]",
    "mesh": "3D 매쉬[OBJ]",
    "meshZip": "3D 매쉬[OBJ](.zip)",
    "dsm": "수치표면모델[DSM-TIF]",
    "dsmZip": "수치표면모델[DSM-TIF](.zip)",
    "orthoDownload": {
      "optionsName": "산출물 다운로드 옵션",
      "loadFailed": "산출물 다운로드 옵션을 불러오지 못했습니다",
      "remainingOf": "남은 횟수 {{remaining}} / {{limit}}",
      "products": {
        "orthomosaic": "정사영상",
        "dsm": "수치표면모델 [DSM-TIF]"
      },
      "files": {
        "dsmGeotiff": "DSM GeoTIFF (.tif)"
      },
      "unavailable": "없음",
      "unavailableNotice": "이 회차에는 이 파일이 없습니다. 필요하면 담당자에게 문의해 주세요.",
      "geotiffGroup": "GeoTIFF (GIS 용)",
      "cadGroup": "CAD 패키지 (AutoCAD·Civil 3D 용)",
      "geotiffHelpLabel": "GeoTIFF 설명",
      "cadHelpLabel": "CAD 패키지 설명",
      "geotiffHelp": "원본은 해상도가 높아 파일이 크고 여는 데 메모리가 많이 필요합니다. 필요한 해상도와 PC 사양에 맞춰 2배·4배 축소본을 받는 것을 권장합니다.\n\n축소본은 처음 요청할 때 한 번 만들어지며, 영상 크기에 따라 몇 분 이상 걸릴 수 있습니다. 한 번 만들어진 뒤에는 바로 받을 수 있고, 생성은 횟수를 소모하지 않습니다.",
      "cadHelp": "PNG·월드파일(.pgw)·좌표계(.prj)·DXF(영상·표고점·고도 숫자)·표고점 CSV(Civil 3D COGO 점)가 포함된 ZIP 입니다. 압축을 풀고 DXF 를 열면 영상이 실제 좌표 위치에 맞춰 자동으로 나타나므로, 위치나 크기를 따로 맞출 필요가 없습니다.\n\n표고점의 고도는 DSM 입니다. 건물·나무·장비 위를 포함한 표면 높이이고, 단위는 정표고 m 입니다. 영상이 투명하거나 DSM 이 비어 있는 자리에는 점이 없습니다.\n\nCAD 패키지는 처음 요청할 때 한 번 만들어지며 시간이 걸릴 수 있습니다.",
      "elevationSpacingNotice": "이 회차는 촬영 범위가 넓어 표고점을 {{spacing}} m 간격으로 넣습니다(기본 5 m).",
      "optionLabel": "{{cm}} cm/px ({{variant}})",
      "variantOriginal": "원본",
      "variantScaled": "{{scale}}배 축소",
      "pixels": "{{width}} × {{height}} px",
      "notGenerated": "생성 전",
      "generate": "생성",
      "generateFor": "생성: {{option}}",
      "download": "다운로드",
      "downloadFor": "다운로드: {{option}}",
      "processing": "생성 중",
      "processingFor": "생성 중: {{option}}",
      "processingProgress": "생성 중 {{progress}}%",
      "failed": "생성 실패",
      "ownerOnly": "산출물 다운로드는 프로젝트 소유자와 관리자 계정만 할 수 있습니다.",
      "limitExhausted": "횟수를 모두 사용했습니다. 추가 다운로드는 담당자에게 연락해 주세요.",
      "notReady": "이 옵션은 아직 준비되지 않았습니다. 상태를 다시 읽어 왔습니다.",
      "concurrencyLimit": "진행 중인 생성이 많아 지금은 시작할 수 없습니다. 잠시 후 다시 시도해 주세요.",
      "requestFailed": "다운로드 요청에 실패했습니다. 다시 시도해 주세요.",
      "confirm": {
        "title": "다운로드 확인",
        "largeImageWarning": "이 영상은 약 {{megapixels}} MP(1억 픽셀 초과)입니다. 파일이 매우 크고 여는 데 많은 메모리가 필요합니다.",
        "originalSlowNotice": "PC 사양과 정사영상 용량에 따라 다운로드가 느릴 수 있습니다. 불편하면 별도로 연락해 주세요.",
        "largeFileWarning": "이 파일은 {{size}} 입니다. 다운로드에 시간이 오래 걸리고 저장 공간이 그만큼 필요합니다.",
        "cancel": "취소",
        "download": "다운로드"
      }
    }
  },
  "myPage": {
    "title": "마이페이지",
    "logout": "로그아웃",
    "menu": {
      "accountInfo": "계정 정보",
      "projectPermission": "프로젝트 권한 관리",
      "projectHistory": "프로젝트 히스토리",
      "withdrawal": "회원탈퇴"
    },
    "account": {
      "title": "계정 정보",
      "name": "이름",
      "email": "이메일",
      "organization": "소속",
      "phone": "휴대폰 번호",
      "field": "분야",
      "role": "직무",
      "password": "비밀번호",
      "passwordConfirm": "비밀번호 확인",
      "currentPassword": "현재 비밀번호",
      "newPassword": "새 비밀번호",
      "changePassword": "비밀번호 변경",
      "save": "저장",
      "cancel": "취소",
      "edit": "수정",
      "timezone": "표시 시간대",
      "timezoneAutoDetected": "(브라우저 자동 감지)"
    },
    "permission": {
      "title": "프로젝트 권한 관리",
      "addUser": "사용자 추가",
      "searchUser": "사용자 검색",
      "userEmail": "사용자 이메일",
      "permission": "권한",
      "role": {
        "owner": "소유자",
        "editor": "편집자",
        "viewer": "뷰어"
      },
      "status": {
        "joined": "가입",
        "notJoined": "미가입"
      },
      "actions": {
        "delete": "삭제",
        "edit": "수정",
        "add": "추가"
      },
      "table": {
        "email": "이메일",
        "name": "이름",
        "permission": "권한",
        "status": "가입 상태",
        "actions": "작업"
      }
    },
    "withdrawal": {
      "title": "회원탈퇴",
      "confirm": "탈퇴하기",
      "cancel": "취소"
    },
    "messages": {
      "passwordChanged": "비밀번호가 변경되었습니다",
      "passwordChangeFailed": "비밀번호 변경에 실패했습니다",
      "accountUpdated": "계정 정보가 수정되었습니다",
      "accountUpdateFailed": "계정 정보 수정에 실패했습니다",
      "userAdded": "사용자가 추가되었습니다",
      "userAddFailed": "사용자 추가에 실패했습니다",
      "userDeleted": "사용자가 삭제되었습니다",
      "userDeleteFailed": "사용자 삭제에 실패했습니다",
      "permissionUpdated": "권한이 수정되었습니다",
      "permissionUpdateFailed": "권한 수정에 실패했습니다",
      "accountDeleteFailed": "계정 삭제에 실패했습니다",
      "ownerTransferred": "소유권을 이전했습니다",
      "confirmDelete": "정말 삭제하시겠습니까?",
      "confirmWithdrawal": "정말 탈퇴하시겠습니까?",
      "projectInfoUpdated": "프로젝트 정보가 수정되었습니다",
      "projectInfoUpdateFailed": "프로젝트 정보 수정에 실패했습니다",
      "timeSeriesUpdated": "시계열 정보가 수정되었습니다",
      "timeSeriesUpdateFailed": "시계열 정보 수정에 실패했습니다",
      "reset": "초기화"
    },
    "history": {
      "sentence": {
        "create": "{{actor}}님이 {{target}}을(를) 추가했습니다",
        "register": "{{actor}}님이 {{target}}을(를) 등록했습니다",
        "update": "{{actor}}님이 {{typeWithKoreanParticle}} \"{{name}}\"(으)로 수정했습니다",
        "delete": "{{actor}}님이 {{target}}을(를) 삭제했습니다",
        "generic": "{{actor}} · {{target}}",
        "memberWithdrawn": "{{actor}}님이 회원 탈퇴로 프로젝트에서 나가셨습니다"
      },
      "type": {
        "project": "프로젝트",
        "time_project": "시계열",
        "member": "멤버",
        "annotation": "어노테이션",
        "annotation_comment": "댓글",
        "annotation_comment_image": "댓글 이미지",
        "category": "카테고리",
        "vector": "3D 측정",
        "clipping": "3D 단면",
        "worksite_zone": "금지구역",
        "geolog": "지오로그",
        "walk_session": "도보 촬영",
        "layer": "레이어",
        "drawing_mesh": "설계도",
        "folder": "폴더",
        "project_equipment": "장비·시설",
        "height_profile_record": "종단면 구간",
        "height_profile_export": "종단면 내보내기"
      },
      "name": {
        "timeProject": "촬영일자 {{name}}",
        "walkSession": "세션 {{name}}"
      },
      "timeProjectFallback": "시계열 #{{id}}",
      "empty": "기록이 없습니다",
      "emptyFiltered": "해당 종류의 기록이 없습니다",
      "noProject": "소속된 프로젝트가 없습니다",
      "forbidden": "이 프로젝트의 기록을 볼 권한이 없습니다",
      "error": "기록을 불러오지 못했습니다",
      "retry": "재시도",
      "loadMore": "더 불러오기"
    }
  },
  "fileList": {
    "dragAndDrop": "파일을 드래그 앤 드롭 해주세요",
    "or": "또는",
    "selectFile": "파일 선택"
  },
  "status": {
    "before": "처리 전",
    "requested": "요청 완료",
    "onProcessing": "처리 중",
    "failed": "처리 실패",
    "reviewing": "검수 중",
    "completed": "처리 완료",
    "completed2d": "2D 완료",
    "completed3d": "3D 완료"
  },
  "droneImageTabs": {
    "list": "업로드 완료 리스트",
    "add": "이미지 추가"
  },
  "projectPermission": {
    "selectProject": "프로젝트 선택",
    "addMember": "멤버 추가",
    "saveChanges": "저장",
    "resetChanges": "초기화",
    "loading": "프로젝트 목록을 불러오는 중...",
    "transferOwner": "소유권 이전"
  }
} as const;

export default projects;
